import React from "react";

// ASSETS
import CalendarIcon from "assets/icons/data.svg";
import WarningIcon from "assets/icons/warning icon web.svg";

// STYLES
import {
  AlertCard,
  BodyWrapper,
  FooterWrapper,
  Icon,
  IconWrapper,
  InfoContainer,
} from "./AlertsCarouselItemStyled";

// LIBRARIES

import { Link } from "react-router-dom";

// MISC

import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { CarouselItemProps } from "components/AlertsCarousel/AlertsCarouselModel";
import { COLORS } from "constants/variables";
import { appRoutes } from "config/AppRoutesConfig";

// REDUX
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";
import { useSelector } from "react-redux";
import { selectLanguage } from "slices/LanguageSlice/languageSlice";

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";

const AlertsCarouselItem: React.FC<CarouselItemProps> = ({
  title,
  body,
  date,
  id,
}) => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);
  const selectedLanguage = useSelector(selectLanguage);

  // STATE CONSTANTS

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS

  const formatDateToMonthDD = (date) => {
    const d = new Date(date);
    const day = d.getDate();
    const year = d.getFullYear();
    const locale = selectedLanguage === "ro" ? "ro-RO" : "en-US";

    let weekday = d.toLocaleDateString(locale, { weekday: "long" });
    let month = d.toLocaleDateString(locale, { month: "long" });

    weekday = weekday.charAt(0).toUpperCase() + weekday.slice(1);
    month = month.charAt(0).toUpperCase() + month.slice(1);

    return `${weekday}, ${day} ${month} ${year}`;
  };

  return (
    <AlertCard
      as={Link}
      to={`${appRoutes.emergencyCommunication}${id}`}
      $biggerCursor={biggerCursor}
    >
      <IconWrapper>
        <Icon src={WarningIcon} alt="" />
      </IconWrapper>
      <InfoContainer>
        <CustomText
          type={TextType.H5}
          text={title}
          color={COLORS.VividAuburn}
        />
        <BodyWrapper>
          <CustomText
            type={TextType.H4officials}
            text={body}
            color={COLORS.RaisinBlack}
          />
        </BodyWrapper>
        <FooterWrapper>
          <Icon src={CalendarIcon} alt="" />
          <CustomText
            type={TextType.P2}
            text={formatDateToMonthDD(date)}
            color={COLORS.MetalicSilver}
          />
        </FooterWrapper>
      </InfoContainer>
    </AlertCard>
  );
};

export default AlertsCarouselItem;
